import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProviderUserPage = lazy(() => import('../views/list/ProviderUserPage'));

export function ProviderUserPageLazy() {
	return (
		<PageSuspense>
			<ProviderUserPage />
		</PageSuspense>
	);
}
